import React from 'react';

import cn from 'classnames';

import { BaseFoldableEntity } from '@vlabs/monokit/shared/ui/foldable-entity';
import type { BaseFoldableEntityProps } from '@vlabs/monokit/shared/ui/foldable-entity';

import st from './FoldableListItem.module.sass';
import { buildTestid } from '../../lib/utils';

export type FoldableListItemProps = BaseFoldableEntityProps;

const displayName = 'FoldableListItem';
const testid = buildTestid(displayName);

function FoldableListItem({
  className,
  children = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: FoldableListItemProps): React.JSX.Element {
  return (
    <BaseFoldableEntity
      className={cn(st.FoldableListItem, className)}
      isOpen={false}
      {...testid(dataTestId)}
      {...props}
    >
      {children}
    </BaseFoldableEntity>
  );
}

FoldableListItem.displayName = displayName;

export { FoldableListItem };
